import { fork } from 'redux-saga/effects';

import * as guarantors from './requests/guarantors-req';
import * as createGuarantor from './requests/create-guarantor-req';
import * as updateGuarantor from './requests/update-guarantor-req';
import * as removeGuarantor from './requests/remove-guarantor-req';
import * as applyGuarantor from './requests/apply-guarantor-req';
import { refetchGuarantorsInformation } from './sagas/refetch-guarantors';
import { applyGuarantorInformation } from './sagas/apply-guarantor';

export default function* guarantorsInformationRootSaga() {
  yield fork(guarantors.watcher);
  yield fork(createGuarantor.watcher);
  yield fork(updateGuarantor.watcher);
  yield fork(removeGuarantor.watcher);
  yield fork(applyGuarantor.watcher);

  yield fork(refetchGuarantorsInformation);
  yield fork(applyGuarantorInformation);
}



// WEBPACK FOOTER //
// ./src/redux/guarantor-information/root-saga.js